document.addEventListener('DOMContentLoaded', function () {

  /* ---- Countdown timer (hero) ---- */
  var countdownEl = document.getElementById('countdown');
  if (countdownEl) {
    var closeDateStr = countdownEl.getAttribute('data-close');
    var closeDate = closeDateStr ? new Date(closeDateStr) : null;
    if (closeDate && !isNaN(closeDate)) {
      var updateCountdown = function () {
        var now = new Date();
        var diff = Math.max(0, closeDate - now);
        var days = Math.floor(diff / (1000 * 60 * 60 * 24));
        var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        var mins = Math.floor((diff / (1000 * 60)) % 60);
        var secs = Math.floor((diff / 1000) % 60);
        var pad = function (n) { return String(n).padStart(2, '0'); };
        var d = document.getElementById('cd-days');
        var h = document.getElementById('cd-hours');
        var m = document.getElementById('cd-mins');
        var s = document.getElementById('cd-secs');
        if (d) d.textContent = pad(days);
        if (h) h.textContent = pad(hours);
        if (m) m.textContent = pad(mins);
        if (s) s.textContent = pad(secs);
      };
      updateCountdown();
      setInterval(updateCountdown, 1000);
    }
  }

  /* ---- Product gallery thumbnails ---- */
  var mainShot = document.getElementById('mainShot');
  document.querySelectorAll('.gallery-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainShot) mainShot.src = thumb.getAttribute('data-full');
    });
  });

  /* ---- Variant picker ---- */
  var variantsScript = document.getElementById('ProductVariants');
  if (!variantsScript) return;

  var variants = JSON.parse(variantsScript.textContent);
  var variantIdInput = document.getElementById('VariantId');
  var priceDisplay = document.getElementById('priceDisplay');
  var compareDisplay = document.getElementById('compareDisplay');
  var colorCaption = document.getElementById('colorCaption');
  var addToCartBtn = document.getElementById('AddToCartBtn');

  var optionRows = document.querySelectorAll('[data-option-index]');
  var selected = {};

  // seed initial selection from whichever option-value already has "active"
  document.querySelectorAll('.option-value.active').forEach(function (el) {
    selected[el.getAttribute('data-option-index')] = el.getAttribute('data-value');
  });

  function moneyFormat(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function findMatchingVariant() {
    var keys = Object.keys(selected).sort();
    return variants.find(function (v) {
      return keys.every(function (idx) {
        var optionKey = 'option' + (parseInt(idx, 10) + 1);
        return v[optionKey] === selected[idx];
      });
    });
  }

  function selectOption(el) {
    var idx = el.getAttribute('data-option-index');
    var value = el.getAttribute('data-value');
    selected[idx] = value;

    // update active states within this option row only
    var row = el.closest('[data-option-index]');
    row.querySelectorAll('.option-value').forEach(function (sib) {
      sib.classList.remove('active');
    });
    el.classList.add('active');

    var match = findMatchingVariant();
    if (!match) return;

    if (variantIdInput) variantIdInput.value = match.id;
    if (priceDisplay) priceDisplay.textContent = moneyFormat(match.price);
    if (compareDisplay) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        compareDisplay.textContent = moneyFormat(match.compare_at_price);
        compareDisplay.style.display = '';
      } else {
        compareDisplay.style.display = 'none';
      }
    }
    if (colorCaption) colorCaption.textContent = match.title;
    if (addToCartBtn) {
      if (match.available) {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = addToCartBtn.getAttribute('data-available-label') || 'Add to cart';
      } else {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = 'Sold out';
      }
    }
    if (match.featured_image && mainShot) {
      mainShot.src = match.featured_image.src.replace(/(\.[a-zA-Z]{3,4})(\?|$)/, '_800x$1$2');
    }
  }

  document.querySelectorAll('.option-value').forEach(function (el) {
    el.addEventListener('click', function () { selectOption(el); });
  });

});
